"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findLabelInArray = findLabelInArray;
exports.specialRuleIdsOptions = exports.sourceOptions = exports.platformIdsOptions = exports.monitorRateIdOptions = void 0;
// 公共选项配置

// 获取数组中指定值的标签
function findLabelInArray(array, value) {
  var _array$find;
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'value';
  return ((_array$find = array.find(function (item) {
    return item[key] === value;
  })) === null || _array$find === void 0 ? void 0 : _array$find.label) || '';
}

// ========== 价格 - 价格监测模块 ==========

// 监控频率
var monitorRateIdOptions = exports.monitorRateIdOptions = [{
  label: '每半小时（每半小时的0秒）',
  value: 1
}, {
  label: '每小时（每小时的0分0秒）',
  value: 2
}, {
  label: '每天（每天的4时0分0秒）',
  value: 3
}, {
  label: '每3天（每3天的4时0分0秒）',
  value: 4
}, {
  label: '每5天（每5天的4时0分0秒）',
  value: 5
}, {
  label: '每周（每周一的4时0分0秒）',
  value: 6
}, {
  label: '每半月（每月1号和15号的4时0分0秒）',
  value: 7
}, {
  label: '每月（每月1号的4时0分0秒）',
  value: 8
}, {
  label: '每季度（每季度第一个月的4时0分0秒）',
  value: 9
}];

// 对比平台、竞品配置、竞品平台
var platformIdsOptions = exports.platformIdsOptions = [{
  label: '淘宝',
  value: 1
}, {
  label: '京东',
  value: 2
}];

// 特殊监控规则
var specialRuleIdsOptions = exports.specialRuleIdsOptions = [{
  label: '当商品价格低于成本价时触发预警',
  value: 1
}, {
  label: '当商品债权抵扣、消费化债金额低于最高化债比例时',
  value: 2
}, {
  label: '当商品债权抵扣、消费化债金额低于最低化债比例时',
  value: 3
}];

// 竞品来源
var sourceOptions = exports.sourceOptions = [{
  label: '爬虫',
  value: 'crawler'
}, {
  label: '手动添加',
  value: 'manual'
}];